import Guardian from "./Guardian";
import common from "../../common";

export default class GuardianWarrior extends Guardian {
    constructor(golden = false) {
        super("guardian_warrior", Guardian.TYPE_WARRIOR, golden);

        this.setIdleAnims(["idle1_warrior"]);
        this.setAttackAnims(["attack_warrior1"]);
        this.setDamageAnims(["damage_warrior1"]);
        this.setDefeatAnims(["defeat_warrior1"]);
        this.setVictoryAnims(["victory_warrior1"]);
        this.setWeaponRevealAnims(["weapon_reveal_warrior1"]);

        this._attackSoundName = "sfx_guardian_hammer_attack_00";
    }
}